export const LIST_STORE_PENDING = 'LIST_STORE_PENDING';
export const LIST_STORE_FULFILLED = 'LIST_STORE_FULFILLED';
export const LIST_STORE_REJECTED = 'LIST_STORE_REJECTED';
